import { type CampaignConfigDefaultProps, INFLUENCER_CONFIGS } from '../influencers.config';

export const useInfluencerConfigs = (campaign?: CampaignConfigDefaultProps) => {
  if (!campaign) return undefined;

  return INFLUENCER_CONFIGS({
    isActive: campaign.isActive,
    ...(campaign.influencerIcon ? { influencerIcon: campaign.influencerIcon } : {}),
    name: campaign.name,
    userFriendlyName: campaign.userFriendlyName,
    percentageOff: campaign.percentageOff,
    ...(campaign.source ? { source: campaign.source } : {}),
    type: campaign.type,
    ...(campaign.urlPath ? { urlPath: campaign.urlPath } : {}),
    ...(campaign.utmCampaign ? { utmCampaign: campaign.utmCampaign } : {}),
  });
};
